import {defineStore} from 'pinia';

import {ModuleBankInfoCategory} from '../moduleConst';

import {BaseDictionaryStore} from '../baseDictionaryStore';

import bankInfoCategoryAPI from '@/apis/di/bankInfoCategoryAPI';

const bankInfoCategoryStore = new BaseDictionaryStore(bankInfoCategoryAPI);

export const useBankInfoCategoryStore = defineStore(ModuleBankInfoCategory, {
  state: () => ({
    ...bankInfoCategoryStore.state,
    _config: {
      key: 'bank_info_category_id',
      code: 'bank_info_category_code',
      name: 'bank_info_category_name',
      table: 'di_bank_info_category',
      quickFollow: 'active',
      moduleName: 'Loại tài khoản ngân hàng, kho bạc',
      defaultSort: 'bank_info_category_code',
    },
    moduleName: 'bankInfoCategory',
  }),
  actions: {...bankInfoCategoryStore.action},
  getters: {
    ...bankInfoCategoryStore.getters,
  },
});
